import { intlLocale } from '../i18n'
/** Public list pricing. Mirrors Billing:PricePerSeatCents and Billing:TrialDays in the API's appsettings. */
export const PRICE_PER_EMPLOYEE_AUD = 11
/** Discount for paying a year up front. Mirrors Billing:AnnualDiscountPercent. */
export const ANNUAL_DISCOUNT_PERCENT = 10
export const TRIAL_DAYS = 14
/** Share of each subscription paid to the referring reseller. Mirrors Reseller.CommissionBps = 1500. */
export const RESELLER_COMMISSION_PERCENT = 15
/** Minimum employee licenses a reseller applicant should have under management. */
export const RESELLER_MIN_LICENSES = 50

/** Price per employee per month on the annual plan (billed once a year), e.g. $11 → $9.90. */
export const ANNUAL_PRICE_PER_EMPLOYEE_MONTHLY_AUD = (PRICE_PER_EMPLOYEE_AUD * (100 - ANNUAL_DISCOUNT_PERCENT)) / 100

/** Yearly software cost for `employees` seats: 12 months less the annual discount. */
export function annualCostAud(employees: number): number {
  return Math.round(employees * PRICE_PER_EMPLOYEE_AUD * 12 * (100 - ANNUAL_DISCOUNT_PERCENT)) / 100
}

export function formatAud(amount: number): string {
  return new Intl.NumberFormat(intlLocale(), { style: 'currency', currency: 'AUD', maximumFractionDigits: amount % 1 === 0 ? 0 : 2 }).format(amount)
}

/** One-off hardware list prices, AUD including GST. */
export const HELMET_TAG_AUD = 30
export const LTE_GATEWAY_AUD = 150
export const BLE_REPEATER_AUD = 80
export const OUTDOOR_GATEWAY_AUD = 350
/** Flat shipping per hardware order within Australia, inc GST. Mirrors the "Delivery (Australia)" price (price_1UJgSPI5AGqgcl4Se4tLrP05) on every Payment Link. */
export const HARDWARE_SHIPPING_AUD = 20
